import React, {useEffect} from "react";
import {
  CancelButton,
  SubmitContainer
} from "../../assets/GlobalStyles";
import {useAtom} from "jotai";
import Table from "../../components/table";
import {
  useLocation,
  useNavigate
} from "react-router-dom";
import {
  budgetTimeDetailColumns,
  budgetTimeListAtom
} from "./entity/BudgetTime";
import {
  selBudgetTimeList
} from "../../services/settings/BudgetTimeAxios";
import styled from "styled-components";

function EventTimeList() {
  const [
    budgetTimeListState,
    setBudgetTimeListState
  ] = useAtom(budgetTimeListAtom);

  const navigate = useNavigate();
  const {state} = useLocation();

  const userId =
      state?.id ??
      budgetTimeListState?.userId;

  useEffect(() => {
    if (!userId) {
      return;
    }

selBudgetTimeList(userId)
.then(response => {
  if (response) {
    setBudgetTimeListState(response);
  }
})
.catch(error => {
  console.error(
    "시간별 예산 그룹 조회 실패:",
    error
  );
});

  }, [userId]);

  const handleCreateBudgetTime = () => {
    navigate(
        "/board/budgetTimeDetail",
        {
          state: {
            id:
                budgetTimeListState?.userId ??
                userId,
            listCount:
                budgetTimeListState?.totalCount ??
                0
          }
        }
    );
  };

  return (
    <Page>
      <PageTitle>시간별 예산 그룹 관리</PageTitle>

      <CardBody>
        <InfoGrid>
          <InfoItem>
            <InfoLabel>
              광고주명
            </InfoLabel>

            <InfoValue>
              {budgetTimeListState
                  ?.adverName ?? "-"}
            </InfoValue>
          </InfoItem>

          <InfoItem>
            <InfoLabel>
              아이디
            </InfoLabel>

            <InfoValue>
              {budgetTimeListState
                  ?.username ?? "-"}
            </InfoValue>
          </InfoItem>

          <InfoItem>
            <InfoLabel>
              담당자
            </InfoLabel>

            <InfoValue>
              {budgetTimeListState
                  ?.managerName ?? "-"}
            </InfoValue>
          </InfoItem>
        </InfoGrid>
      </CardBody>
      <SettingCard>



        <SectionHeader>
          <HeaderTitleArea>
            <HeaderAccent />
            <div>
              <SectionTitleLine>
                <SectionTitle>시간별 예산 그룹</SectionTitle>
                <ResultCount>
                  <strong>{budgetTimeListState?.totalCount ?? 0}</strong>
                  <span>건</span>
                </ResultCount>
              </SectionTitleLine>
              <SectionDescription>
                등록된 시간별 예산 그룹을 확인하고 새로운 그룹을 추가합니다.
              </SectionDescription>
            </div>
          </HeaderTitleArea>

          <AddButton
              type="button"
              onClick={
                handleCreateBudgetTime
              }
          >
            + 예산 그룹 추가
          </AddButton>
        </SectionHeader>

        <TableBody>
          <ScrollGuide>Shift + 스크롤로 좌우 이동</ScrollGuide>
          <TableContainer>
            {budgetTimeListState && (
                <Table
                    variant="schedule"
                    hideToolbar={true}
                    columns={budgetTimeDetailColumns}
                    data={budgetTimeListState?.timeGroups ?? []}
                    style={{minHeight: 260}}
                    emptyText="등록된 시간별 예산 그룹이 없습니다."
                />
            )}
          </TableContainer>
        </TableBody>
      </SettingCard>

      <BottomActionBar>
        <BottomActionGuide>
          <BottomActionTitle>시간별 예산 목록을 확인했습니다.</BottomActionTitle>
          <BottomActionDescription>
            설정 메뉴로 돌아가거나 필요한 예산 그룹을 선택해 관리할 수 있습니다.
          </BottomActionDescription>
        </BottomActionGuide>
        <BottomActionButtons>
          <CancelButton
              type="button"
              onClick={() => navigate('/board/settings')}
          >
            목록
          </CancelButton>
        </BottomActionButtons>
      </BottomActionBar>
    </Page>
  );
}

export default EventTimeList;

const Page = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
`;

const PageTitle = styled.h2`
  margin: 0;
  color: #222;
  font-size: 22px;
  font-weight: 700;
`;

const BottomActionBar = styled(SubmitContainer)`
  position: sticky;
  bottom: 0;
  z-index: 5;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  padding: 16px 20px;
  border: 1px solid #ffd7b5;
  border-left: 4px solid #f5811f;
  border-radius: 10px;
  background: linear-gradient(90deg, #fff8f2 0%, rgba(255, 255, 255, 0.98) 48%);
  box-shadow: 0 -4px 20px rgba(245, 129, 31, 0.09);

  button {
    width: auto;
    min-width: 108px;
    height: 40px;
    margin: 0;
    padding: 0 22px;
    border-color: #f5811f;
    border-radius: 6px;
    background: #f5811f;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 5px 12px rgba(245, 129, 31, 0.2);

    &:hover:not(:disabled) {
      border-color: #e9700d;
      background: #e9700d;
    }
  }

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

const BottomActionGuide = styled.div`
  min-width: 0;
  text-align: left;
`;

const BottomActionTitle = styled.strong`
  display: block;
  color: #2f3438;
  font-size: 14px;
  font-weight: 800;
`;

const BottomActionDescription = styled.span`
  display: block;
  margin-top: 4px;
  color: #7f878e;
  font-size: 12px;
  line-height: 1.45;
`;

const BottomActionButtons = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;

  @media (max-width: 640px) {
    width: 100%;
    flex-direction: column;
  }
`;

const SettingCard = styled.section`
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const SectionHeader = styled.header`
  display: flex;
  min-height: 74px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border-top: 0;
  border-bottom: ${props => props.$subsection ? "0" : "1px solid #eee"};
  background-color: ${props => props.$subsection ? "#fff" : "#f9fafb"};
`;

const HeaderTitleArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
`;

const HeaderAccent = styled.span`
  width: 4px;
  height: 34px;
  flex: 0 0 4px;
  border-radius: 2px;
  background-color: #f5811f;
`;

const SectionTitle = styled.div`
  color: #222;
  font-size: 17px;
  font-weight: 700;
`;

const SectionTitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SectionDescription = styled.div`
  margin-top: 5px;
  color: #888;
  font-size: 12px;
  line-height: 1.5;
`;

const CardBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns:
  repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background-color: #fff;

@media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
  `;

const ResultCount = styled.div`
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  gap: 4px;
  padding: 0 9px;
  border: 1px solid #f1d4c2;
  border-radius: 13px;
  background-color: #fff4e8;

  & strong {
    color: #f5811f;
    font-size: 13px;
  }

  & span {
    color: #888;
    font-size: 11px;
  }
`;

const InfoItem = styled.div`
  min-height: 92px;
  padding: 18px 20px;
  border-right: 1px solid #eeeeee;

&:last-child {
    border-right: 0;
  }

@media (max-width: 900px) {
    min-height: auto;
    border-right: 0;
    border-bottom: 1px solid #eeeeee;

&:last-child {
  border-bottom: 0;
}

  }
  `;

const InfoLabel = styled.div`  margin-bottom: 9px;
  color: #888;
  font-size: 14px;`;

const InfoValue = styled.div`  overflow: hidden;
  color: #333;
  font-size: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;`;

const AddButton = styled.button`
  height: 34px;
  padding: 0 14px;
  border: 1px solid #f5811f;
  border-radius: 6px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

&:hover {
    background-color: #ffe8d2;
  }
  `;

const TableBody = styled.div`
  padding: 14px 20px 20px;
`;

const ScrollGuide = styled.div`
  margin-bottom: 8px;
  color: #999;
  font-size: 12px;
  text-align: right;
`;

const TableContainer = styled.div`
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 8px;
  background-color: #fff;

  & > div,
  & > section,
  & > section > div:last-child,
  .InovuaReactDataGrid,
  .inovua-react-toolkit-table {
    margin: 0;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .InovuaReactDataGrid__header,
  .inovua-react-toolkit-table thead {
    background-color: #f7f7f7;
  }

  .InovuaReactDataGrid__row:hover,
  tbody tr:hover {
    background-color: #fffaf6;
  }

  table {
    width: 100%;
  }

  thead th {
    background-color: #f7f7f7;
    color: #555;
    font-size: 15px;
    font-weight: 600;
  }

  tbody td {
    color: #444;
    font-size: 15px;
  }

  tbody tr:hover {
    background-color: #fffaf6;
  }
  `;
